import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createElementVNode as _createElementVNode, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "column items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createBlock(_component_q_input, _mergeProps({
    autofocus: _ctx.autofocus,
    "model-value": _ctx.modelValue,
    "onUpdate:modelValue": _ctx.update
  }, _ctx.sizeMap.get(_ctx.size), {
    "label-slot": _ctx.labelSlot,
    "hide-bottom-space": !_ctx.bottomSlots && !_ctx.errorSlot,
    "bottom-slots": _ctx.bottomSlots,
    "error-slot": _ctx.errorSlot,
    "lazy-rules": "",
    rules: [_ctx.validateAmountField]
  }), _createSlots({
    prepend: _withCtx(() => [
      _renderSlot(_ctx.$slots, "prepend")
    ]),
    append: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, [
          _createVNode(_component_q_btn, _mergeProps(_ctx.BTN_TERTIARY_XS, { onClick: _ctx.stepUp }), {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: _ctx.ICONS_NAME.CHEVRON_UP_OUTLINE
              }, null, 8, ["name"])
            ]),
            _: 1
          }, 16, ["onClick"])
        ]),
        _createElementVNode("span", null, [
          _createVNode(_component_q_btn, _mergeProps(_ctx.BTN_TERTIARY_XS, { onClick: _ctx.stepDown }), {
            default: _withCtx(() => [
              _createVNode(_component_q_icon, {
                name: _ctx.ICONS_NAME.CHEVRON_DOWN_OUTLINE
              }, null, 8, ["name"])
            ]),
            _: 1
          }, 16, ["onClick"])
        ])
      ])
    ]),
    _: 2
  }, [
    (_ctx.labelSlot)
      ? {
          name: "label",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "label")
          ]),
          key: "0"
        }
      : undefined,
    (_ctx.errorSlot)
      ? {
          name: "error",
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, "error")
          ]),
          key: "1"
        }
      : undefined
  ]), 1040, ["autofocus", "model-value", "onUpdate:modelValue", "label-slot", "hide-bottom-space", "bottom-slots", "error-slot", "rules"]))
}